import{React, useHistory, useContext} from 'external/react'

import {
  makeStyles,
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  CircularProgress,
  useMediaQuery,
  useTheme,
  IconButton,
  CloseIcon
} from 'external/material'

import {TeacherContext} from 'teacher/context'
import {isUUID} from 'helpers/utils'
import AssessmentStandards from './index'

const useDialogStyles = makeStyles(dialogStyles)
const useDialogTitleStyles = makeStyles(dialogTitleStyles)
const useDialogContentStyles = makeStyles(dialogContentStyles)

export default function AssessmentStandardsDialog (props) {

  const dialogClasses = useDialogStyles()
  const dialogTitleClasses = useDialogTitleStyles()
  const dialogContentClasses = useDialogContentStyles()
  const history = useHistory()
  const theme = useTheme()
  const context = useContext(TeacherContext)
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))

  const {assessment, link, sectionName, standardsContext, translate, quizTypesMap} = context 
  const {assessmentStandards, assessment: properties} = standardsContext 
  const {closePath} = props

  const inStandards = sectionName == 'standards'
  const open = inStandards && isUUID(assessment)
  const handleClose = () => history.push(closePath || link('quiz', 'assessments'))

  const title = properties.title != undefined
                ? translate('assessment-standards-title-dialog', {title: properties.title, type: translate(quizTypesMap[properties.type])})
                : translate('standards')

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      classes={assessmentStandards.loaded && !fullScreen ? dialogClasses : undefined}
      onClose={handleClose}
      aria-labelledby="assessment-standards-dialog-title"
    >
      {assessmentStandards.loaded && (
      <DialogTitle id="assessment-standards-dialog-title" classes={dialogTitleClasses}>
        {assessmentStandards.loaded && <Typography variant="h5" component="h2" className="title">{title}</Typography>}
        <IconButton
          aria-label="close"
          className="closeButton"
          onClick={handleClose}
          size="large">
          <CloseIcon />
        </IconButton>
      </DialogTitle>)}
      <DialogContent classes={dialogContentClasses}>
        {!assessmentStandards.loaded && <Box className="progress"><CircularProgress /></Box>}
        <AssessmentStandards Wrapper={DialogWrapper} withReferences={false} />
      </DialogContent>
    </Dialog>
  );
}

function DialogWrapper (props) {
  return (<Box className="contentWrapper">{props.children}</Box>)
}

function dialogTitleStyles(theme){
  return {
    root: {
      borderBottom: 'solid 1px #e0e0e0',
      padding: '16px 3px 16px 24px',
      display: 'flex',
      "& .title": {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        color: '#3f5250',
        flexGrow: 1,
      },
    },
  }
}

function dialogContentStyles() {
  return {
    root: {
      display: 'flex',
      justifyContent: 'center',
      padding: 0,
      "& .contentWrapper": {
        display: 'flex',
        flexGrow: 1
      },
      "& .progress": {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }
    }
  }
}

function dialogStyles(theme) {
  return {
    container: { 
      display: 'flex',
      color: '#626d88',
      width: '100%',
      height: '100%',
      justifyContent: 'center',
    },
    paper: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#fff',
      border: 'solid 1px #dce1ec',
      height: 'calc(100% - 40px)',
      minWidth: 600,
      maxWidth: 1024,
      borderRadius: 2,
      width: '80%'
    }
  }
}
